import { useMutation } from "@tanstack/react-query";
import { useRestAPI } from "./axiosAPI";

export function useReportAPIs() {

    const api = useRestAPI()


    const { mutateAsync: downloadSEwiseReport, isPending: isDownloadingProductDatas, failureCount: failureProductDatas, isError: isErrorDownloadingProductDatas } = useMutation({
        mutationFn: async ({seIds,date}:{seIds:number[],date:string}) => {

            
            const response = await api.get({
                url: `${process.env.REACT_APP_BACKEND_URL}/transactions/report-sewise-forecast/?${seIds.map(item=>`seId=${item}`).join('&')}`,
                mode: 'protected',
                responseType: 'blob',
                params:{
                    date
                }
            })


            if (response.success === false && (response.message === 'Network Error' || response.message === 'Server Error') && failureProductDatas < 1) {

                // setDeleteRetryCount((prev)=>prev+1)
                return response
            }
            if (response.success !== false) {
                const blob = new Blob([response as unknown as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'SE_Forcast_report.xlsx'; // Set the filename

                // Append to the document and trigger the download
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }

            return response
        },
        retry: 1,

    })
    const { mutateAsync: downloadForecastVariationReport, isPending: isdownloadForecastVariationReports, failureCount: failuredownloadForecastVariationReport, isError: isErrorDownloadingdownloadForecastVariationReport } = useMutation({
        mutationFn: async ({stateId,date,stateName}:{stateId:number,date:string,stateName:string}) => {

            
            const response = await api.get({
                url: `${process.env.REACT_APP_BACKEND_URL}/transactions/report-variation-forecast/`,
                mode: 'protected',
                responseType: 'blob',
                params:{
                    date,
                    state_id:stateId
                }
            })


            if (response.success === false && (response.message === 'Network Error' || response.message === 'Server Error') && failureProductDatas < 1) {

                // setDeleteRetryCount((prev)=>prev+1)
                return response
            }
            if (response.success !== false) {
                const blob = new Blob([response as unknown as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `Forecast_Variation_${stateName}.xlsx`; // Set the filename

                // Append to the document and trigger the download
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }

            return response
        },
        retry: 1,

    })
    const { mutateAsync: downloadStylewiseTargetReport, isPending: isdownloadStylewiseTargetReport, failureCount: failuredownloadStylewiseTargetReport, isError: isErrorDownloadingdownloadStylewiseTargetReport } = useMutation({
        mutationFn: async ({date}:{date:string}) => {

            
            const response = await api.get({
                url: `${process.env.REACT_APP_BACKEND_URL}/transactions/report-stylewise-forecast/`,
                mode: 'protected',
                responseType: 'blob',
                params:{
                    date,
                }
            })


            if (response.success === false && (response.message === 'Network Error' || response.message === 'Server Error') && failuredownloadStylewiseTargetReport < 1) {

                // setDeleteRetryCount((prev)=>prev+1)
                return response
            }
            if (response.success !== false) {
                const blob = new Blob([response as unknown as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `Stylewise_Target.xlsx`; // Set the filename

                // Append to the document and trigger the download
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }

            return response
        },
        retry: 1,

    })



  

    return {
        downloadSEwiseReport,
        isDownloadingProductDatas,
        downloadForecastVariationReport,
        isdownloadForecastVariationReports,
        downloadStylewiseTargetReport,
        isdownloadStylewiseTargetReport
    }

}
